/**
 * Datatable definition for the Vendors table.
 */


var app_vendors_table = $('#app-vendors-table');

$('#add_contact_vendor').on('click', function () {
    var selectedItems = [];
    $('.vendors_check input[type=checkbox]').each(function () {
        if (this.checked)
            selectedItems.push($(this).val());
    });
    if (selectedItems.length > 0) {
        show_loader();
        $.ajax({
            type: 'GET',
            url: '/vendors/get_contacts/to_vendor',
            dataType: 'json',
            encode: true,
            success: function (data) {
                $('#add_contact_name').select2({
                    multiple: true,
                    placeholder: 'Select at least one...',
                    closeOnSelect: false,
                    'allowClear': true,
                }).on('select2:opening select2:closing', function (event) {
                    var $searchfield = $(this).parent().find('.select2-search__field');
                    $searchfield.prop('disabled', false);
                });

                $('#add_contact_name').html('');

                var html = '';
                for (var i in data) {
                    console.log(data[i]['id'] + '***********************************'+ data[i]['contact_name'] );
                    html += '<option value=" ' + data[i]['id'] + '">' + data[i]['contact_name'] + '</option>';
                }
                $("#add_contact_name").html(html);
                $('#addContact').modal('show');
                hide_loader();
            },
            error: function (xhr) {
                hide_loader();
                debug(xhr.responseText);
            }
        });
    }
    else{
        $('#generalWarningModalDiv').html('Please select at least one Vendor.');
        $('#generalWarningModal').modal('show');
    }
});
$('#create_contact_vendor_fromtemplate').on('click', function () {

        $.ajax({
            type: 'GET',
            url: '/vendors/get_contacts/to_vendor',
            dataType: 'json',
            encode: true,
            success: function (data) {
                $('#add_contact_name_template').select2({
                    minimumResultsForSearch: 5,
                    placeholder: 'Select at  one...',

                });

                $('#add_contact_name_template').html('');

                var html = '';
                for (var i in data) {
                    console.log(data[i]['id'] + '***********************************'+ data[i]['contact_name'] );
                    html += '<option value=" ' + data[i]['id'] + '">' + data[i]['contact_name'] + '</option>';
                }
                $("#add_contact_name_template").html(html);
                $('#createContactfromTemplate').modal('show');
            },
            error: function (xhr) {
                hide_loader();
                debug(xhr.responseText);
            }
        });

});

$('#confirm_add_contact_tovendor').on('click', function () {
    show_loader();
    var url = $(this).attr('data-url');
    var selectedItems = [];
    $('.vendors_check input[type=checkbox]').each(function () {
        if (this.checked)
            selectedItems.push($(this).val());
    });
    var params = {
        vendors: selectedItems,
        contacts: $('#add_contact_name').val(),
    };
    if($('#add_contact_name').val() != '') {
        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data: JSON.stringify(params),
            url: url,
            dataType: "json",
            contentType: "application/json",
            success: function (response) {
                global_notification('success', 'Contacts added...');
                $('#addContact').modal('hide');
                hide_loader();
            },
            error: function (xhr) {
                hide_loader();
                ajax_error();
                debug(xhr.responseText);

            }
        });
    }
    else{
        $('#generalWarningModalDiv').html('Please select at least one Contact.');
        $('#generalWarningModal').modal('show');
    }


});

$('#confirm_contact_template').on('click', function () {

   var contact_id= $('#add_contact_name_template option:selected').val();

    if($('#add_contact_name_template option:selected').val() != '') {
        show_loader();
        $.ajax({
            type: 'GET',
            url: '/vendors/get_contacts/totemplate/' + contact_id,
            dataType: 'json',
            encode: true,
            success: function (data) {
                $('#vendor_contact_name').val(data.contact_name);
                $('.vendor_contact_title').val(data.contact_title);
                $('#vendor_address_line_1').val(data.address_line_1);
                $('#vendor_address_line_2').val(data.address_line_2);
                $('#vendor_address_city').val(data.city);
                $('#vendor_address_region').val(data.region);
                $('#vendor_address_postal_code').val(data.postal_code);
                $('#vendor_address_nation').val(data.nation);
                $('#vendor_phone').val(data.phone);
                $('#vendor_fax').val(data.fax);
                $('#vendor_email').val(data.email);
                $('#vendor_website').val(data.webside);
                $('#vendor_comment').val(data.comment);

                $('#createContactfromTemplate').modal('hide');
                hide_loader();
            },
            error: function (xhr) {
                hide_loader();
                ajax_error();
                debug(xhr.responseText);

            }
        });
    }
    else
        global_notification('warning', 'Please select a contact...');

});

$("#vendor_print_options").multiSelect({
    selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
    selectionHeader: "<div style='height: 38px;'><input type='button' class='btn btn-primary m-r-5 btn-sm ' value='Select All' id='select_all_print_opt' >&nbsp;<input type='button' class='btn btn-primary m-r-5 btn-sm ' value='Deselect All' id='deselect_all_print_opt'></div>",
    selectAllText: 'Select All',
    deselectAllText: 'Deselect All',
    afterInit: function(ms){
        var that = this,
            $selectableSearch = that.$selectableUl.prev(),
            selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

        that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
            .on('keydown', function(e){
                if (e.which === 40){
                    that.$selectableUl.focus();
                    return false;
                }
            });
    },
    afterSelect: function(values){
        this.qs1.cache();
    },
    afterDeselect: function(values){
        this.qs1.cache();
    }
});

$('#select_all_print_opt').on('click', function () {
    $('#vendor_print_options').multiSelect('select_all');
});

$('#deselect_all_print_opt').on('click', function () {
    $('#vendor_print_options').multiSelect('deselect_all');
});

$("#vendor_markets_print").multiSelect({
    selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
    selectionHeader: "<div style='height: 38px;'><label>Selected</label></div>",
    selectableFooter: "<div style='height: 38px;'>" +
        "<input type='button' class='btn btn-primary m-r-5 btn-sm ' value='Select Custom' id='select_all_printcustom' >&nbsp;" +
        "<input type='button' class='btn btn-primary m-r-5 btn-sm ' value='Select MSA' id='select_all_print_msa' >&nbsp;" +
        "<input type='button' class='btn btn-primary m-r-5 btn-sm ' value='Select DMA' id='select_all_print_dma' >" +
        "</div>",
    selectionFooter: "<div style='height: 38px;'>" +
        "<input type='button' class='btn btn-primary m-r-5 btn-sm ' value='Deselect Custom' id='deselect_all_print_custom'>&nbsp;" +
        "<input type='button' class='btn btn-primary m-r-5 btn-sm ' value='Deselect MSA' id='deselect_all_print_msa'>&nbsp;" +
        "<input type='button' class='btn btn-primary m-r-5 btn-sm ' value='Deselect DMA' id='deselect_all_print_dma'>" +
        "</div>",
    selectAllText: 'Select All',
    deselectAllText: 'Deselect All',
    afterInit: function(ms){
        var that = this,
            $selectableSearch = that.$selectableUl.prev(),
            selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

        that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
            .on('keydown', function(e){
                if (e.which === 40){
                    that.$selectableUl.focus();
                    return false;
                }
            });
    },
    afterSelect: function(values){
        this.qs1.cache();
    },
    afterDeselect: function(values){
        this.qs1.cache();
    }
});

$('#select_all_print_msa').on('click', function () {
    show_overlay_loader($("#exportVendorModal .modal-content"));
    $('#vendor_markets_print option').each(function () {
        if($(this).parent().attr('label') === 'MSA'){
            $(this).prop('select', true)
            $('#vendor_markets_print').multiSelect('select', [$(this).val()]);
        }
    });
    hide_loader();
});

$('#deselect_all_print_msa').on('click', function () {
    show_overlay_loader($("#exportVendorModal .modal-content"));
    $('#vendor_markets_print option').each(function () {
        if($(this).parent().attr('label') === 'MSA'){
            $(this).prop('select', false)
            $('#vendor_markets_print').multiSelect('deselect', [$(this).val()]);
        }
    });
    hide_loader();
});

$('#select_all_print_dma').on('click', function () {
    show_overlay_loader($("#exportVendorModal .modal-content"));
    $('#vendor_markets_print option').each(function () {
        if($(this).parent().attr('label') === 'DMA'){
            $(this).prop('select', true)
            $('#vendor_markets_print').multiSelect('select', [$(this).val()]);
        }
    });
    hide_loader();
});

$('#deselect_all_print_dma').on('click', function () {
    show_overlay_loader($("#exportVendorModal .modal-content"));
    $('#vendor_markets_print option').each(function () {
        if($(this).parent().attr('label') === 'DMA'){
            $(this).prop('select', false)
            $('#vendor_markets_print').multiSelect('deselect', [$(this).val()]);
        }
    });
    hide_loader();
});

$('#select_all_print_custom').on('click', function () {
    show_overlay_loader($("#exportVendorModal .modal-content"));
    $('#vendor_markets_print option').each(function () {
        if($(this).parent().attr('label') === 'Custom'){
            $(this).prop('select', true)
            $('#vendor_markets_print').multiSelect('select', [$(this).val()]);
        }
    });
    hide_loader();
});

$('#deselect_all_print_custom').on('click', function () {
    show_overlay_loader($("#exportVendorModal .modal-content"));
    $('#vendor_markets_print option').each(function () {
        if($(this).parent().attr('label') === 'Custom'){
            $(this).prop('select', false)
            $('#vendor_markets_print').multiSelect('deselect', [$(this).val()]);
        }
    });
    hide_loader();
});

$("#vendor_export_options").multiSelect({
    selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
    selectionHeader: "<div style='height: 38px;'><input type='button' class='btn btn-primary m-r-5 btn-sm  btn-outline' value='Select All' id='select_all_opt' >&nbsp;<input type='button' class='btn btn-primary m-r-5 btn-sm btn-outline' value='Deselect All' id='deselect_all_opt'></div>",
    selectAllText: 'Select All',
    deselectAllText: 'Deselect All',
    afterInit: function(ms){
        var that = this,
            $selectableSearch = that.$selectableUl.prev(),
            selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

        that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
            .on('keydown', function(e){
                if (e.which === 40){
                    that.$selectableUl.focus();
                    return false;
                }
            });
    },
    afterSelect: function(values){
        this.qs1.cache();
    },
    afterDeselect: function(values){
        this.qs1.cache();
    }
});

$('#select_all_opt').on('click', function () {
    $('#vendor_export_options').multiSelect('select_all');
});

$('#deselect_all_opt').on('click', function () {
    $('#vendor_export_options').multiSelect('deselect_all');
});

$("#vendor_markets_excel").multiSelect({
    selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
    selectionHeader: "<div style='height: 38px; margin-top: 2%''><label>Selected</label></div>",
    selectableFooter: "<div style='height: 38px; margin-top: 2%''>" +
        "<input type='button' class='btn btn-primary m-r-5 btn-sm  btn-outline' value='Select Custom' id='select_all_mark_custom' >&nbsp;" +
        "<input type='button' class='btn btn-primary m-r-5 btn-sm  btn-outline' value='Select MSA' id='select_all_mark_msa' >&nbsp;" +
        "<input type='button' class='btn btn-primary m-r-5 btn-sm  btn-outline' value='Select DMA' id='select_all_mark_dma' >" +
        "</div>",
    selectionFooter: "<div style='height: 38px; margin-top: 2%'>" +
        "<input type='button' class='btn btn-primary m-r-5 btn-sm  btn-outline' value='Deselect Custom' id='deselect_all_mark_custom'>&nbsp;" +
        "<input type='button' class='btn btn-primary m-r-5 btn-sm  btn-outline' value='Deselect MSA' id='deselect_all_mark_msa'>&nbsp;" +
        "<input type='button' class='btn btn-primary m-r-5 btn-sm  btn-outline' value='Deselect DMA' id='deselect_all_mark_dma'>" +
        "</div>",
    selectAllText: 'Select All',
    deselectAllText: 'Deselect All',
    afterInit: function(ms){
        var that = this,
            $selectableSearch = that.$selectableUl.prev(),
            selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

        that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
            .on('keydown', function(e){
                if (e.which === 40){
                    that.$selectableUl.focus();
                    return false;
                }
            });
    },
    afterSelect: function(values){
        this.qs1.cache();
    },
    afterDeselect: function(values){
        this.qs1.cache();
    }
});

$('#select_all_mark_msa').on('click', function () {
    show_overlay_loader($("#exportVendorModal .modal-content"));
    $('#vendor_markets_excel option').each(function () {
        if($(this).parent().attr('label') === 'MSA'){
            $(this).prop('select', true)
            $('#vendor_markets_excel').multiSelect('select', [$(this).val()]);
        }
    });
    hide_loader();
});

$('#deselect_all_mark_msa').on('click', function () {
    show_overlay_loader($("#exportVendorModal .modal-content"));
    $('#vendor_markets_excel option').each(function () {
        if($(this).parent().attr('label') === 'MSA'){
            $(this).prop('select', false)
            $('#vendor_markets_excel').multiSelect('deselect', [$(this).val()]);
        }
    });
    hide_loader();
});

$('#select_all_mark_dma').on('click', function () {
    show_overlay_loader($("#exportVendorModal .modal-content"));
    $('#vendor_markets_excel option').each(function () {
        if($(this).parent().attr('label') === 'DMA'){
            $(this).prop('select', true)
            $('#vendor_markets_excel').multiSelect('select', [$(this).val()]);
        }
    });
    hide_loader();
});

$('#deselect_all_mark_dma').on('click', function () {
    show_overlay_loader($("#exportVendorModal .modal-content"));
    $('#vendor_markets_excel option').each(function () {
        if($(this).parent().attr('label') === 'DMA'){
            $(this).prop('select', false)
            $('#vendor_markets_excel').multiSelect('deselect', [$(this).val()]);
        }
    });
    hide_loader();
});

$('#select_all_mark_custom').on('click', function () {
    show_overlay_loader($("#exportVendorModal .modal-content"));
    $('#vendor_markets_excel option').each(function () {
        if($(this).parent().attr('label') === 'Custom'){
            $(this).prop('select', true)
            $('#vendor_markets_excel').multiSelect('select', [$(this).val()]);
        }
    });
    hide_loader();
});

$('#deselect_all_mark_custom').on('click', function () {
    show_overlay_loader($("#exportVendorModal .modal-content"));
    $('#vendor_markets_excel option').each(function () {
        if($(this).parent().attr('label') === 'Custom'){
            $(this).prop('select', false)
            $('#vendor_markets_excel').multiSelect('deselect', [$(this).val()]);
        }
    });
    hide_loader();
});

if (app_vendors_table.length) {

    $('#print_vendors').on('click', function () {
        $('#export_submit').hide();
        $('#print_submit').show();
        var mymodal = $('#exportVendorModal');
        mymodal.modal('show');

    });

    $('#export_vendors').on('click', function () {
        $('#export_submit').show();
        $('#print_submit').hide();
        var mymodal = $('#exportVendorModal');
        mymodal.modal('show');
    });
    $('#export_submit').on('click', function () {
        show_loader();
        var arr = {
            'vendor_markets_print': $('#vendor_markets_excel').val() ,
            'vendor_print_options': $('#vendor_export_options').val(),
            'show_all_contacts': typeof $("input:checkbox[name=show_all_contacts]:checked").attr('value') !== 'undefined' ? 1 : 0,
        };
        console.log('arr ',arr);
        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            url: $(this).attr('data-contact-url'),
            data: JSON.stringify(arr),
            contentType: "application/json",
            dataType: 'json',
            encode: true,
            success: function (data) {
                hide_loader();
                exportToExcel(data.data);

            },

            error: function (xhr) {
                hide_loader();
                ajax_error();
                debug(xhr.responseText);


            }
        });
        var mymodal = $('#exportVendorModal');

        mymodal.modal('hide');

    });

    function exportToExcel(html){
        // var url = 'data:application/vnd.ms-excel,' + encodeURIComponent(html);
        // location.href=url;
        // return false;
        var myBlob =  new Blob( [html] , {type:'application/vnd.ms-excel'});
        var url = window.URL.createObjectURL(myBlob);
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.href = url;
        a.download = "vendors-export.xls";
        a.click();
    }

    $('#print_submit').on('click', function () {
    if ($('#vendor_markets_excel').val().length > 0) {
        var arr = {
            'markets': $('#vendor_markets_excel').val(),
            'options': $('#vendor_export_options').val(),
            'show_all_contacts': typeof $("input:checkbox[name=show_all_contacts]:checked").attr('value') !== 'undefined' ? 1 : 0,
        };
        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            url: '/vendors/report/save',
            data: JSON.stringify(arr),
            contentType: "application/json",
            dataType: 'json',
            encode: true,
            success: function (data) {
                var link = document.createElement('a');
                link.href = "/vendors/report/" + data + "/download";
                $(link).attr('target', '_blank');
                link.click();
            },
            error: function (xhr) {
                debug(xhr.responseText);
            }
        });

    } else
        global_notification('warning', 'Should select at least one market.')
});
    var app_vendors_table_datatable;

    function reInitVendorDatatable() {

    }

    $('#submit-search-vendor-index').on('click', function () {
        SearchVendor();
    });
    function SearchVendor() {
        var market= $('#market-search-vendor-index').val();
        var market_msa= $('#market-search-vendor-index-msa').val();
        var market_custom= $('#market-search-vendor-index-custom').val();
        var media= $('#media-search-vendor-index').val();
        var owner= $('#owner-search-vendor-index').val();
        var vendor_id= $('#vendor-id-search-vendor-index').val();
        var vendor_pub= $('#vendor-pub-search-vendor-index').val();

        if((market_custom =='' || market_custom== null) && (  market_msa=='' || market_msa== null) &&(  market=='' || market== null) &&(typeof media=='undefined' || media=='' || media== null) && (owner =='' || owner== null) && (vendor_id =='' || vendor_id== null)  && (vendor_pub =='' || vendor_pub== null))
            global_notification('warning', 'Please select at least one search parameter...');
        else {
            show_loader();

            var params = {
                market: market,
                market_msa: market_msa,
                market_custom: market_custom,
                media: media,
                owner: owner,
                vendor_id: vendor_id,
                vendor_pub: vendor_pub
            };
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                url: "/vendors/search/index",
                data: JSON.stringify(params),
                contentType: "application/json",
                dataType: 'json',
                encode: true,
                success: function (data) {
                    console.log('********************');
                    console.log(app_vendors_table);
                    console.log(data);
                    var medias = '';
                    if(medias !== "") {
                        if(medias === 'tv')
                            medias = "?type=dma";
                        else if(medias === 'radio')
                            medias = "?type=msa"
                        else if(typeof create_type !== "undefined" && create_type !== "")
                            medias = "?type="+create_type
                    }else if(typeof create_type !== "undefined" && create_type !== "")
                        medias = "?type="+create_type
                    var marks  = '';
                    if(marks !== "")
                        marks = ((medias !== "") ? "&" : "?") + "market=" + marks;
                    $("#app-vendors-table").dataTable().fnDestroy();
                    $("#app-vendors-table tbody").html('');
                    $('#app-vendors-table thead tr.filters').remove();
                    global_notification('warning', 'You need to Reset the Search Vendor form in order to be able to filter by column.');
                    app_vendors_table_datatable = $('#app-vendors-table').DataTable({
                        "processing": true,
                        "serverSide": false,
                        language: {
                            "infoFiltered":"",
                            "loadingRecords": '<i class="fa fa-fw fa-spinner fa-spin" style="font-size: 18px;"></i> Searching'
                        },
                        columns: [
                            {data: 'id'},
                            {data: 'name'},
                            {data: 'owner'},
                            {data: 'types'},
                            {data: 'markets'},
                            {data: 'vendor_code'},
                            {data: 'vendor_pub'},
                            {data: 'slug'}
                        ],
                        destroy: true,
                        pageLength: user_entries,
                        order: data_table_order,
                        "columnDefs": [
                            {
                                "targets": 7,
                                "orderable": false,
                            },
                            {
                                "targets": 5,
                                "orderable": true,
                                "searchable": true,
                            },
                            {
                                "targets": 6,
                                "orderable": true,
                                "searchable": true,
                            },{
                                "targets": 3,
                                "orderable": false,
                                "createdCell": function (td, cellData, rowData, row, col) {
                                    $(td).html('');
                                    $.each(cellData, function (index, value) {
                                        $(td).append(value['name'].toUpperCase());
                                        if (index != (cellData.length - 1)) {
                                            $(td).append(' / ');
                                        }
                                    });
                                }
                            },
                            {
                                "targets": 0,
                                "orderable": false,
                                "createdCell": function (td, cellData, rowData, row, col) {
                                    if(rowData.delete== 1)
                                        var html = ' <div class="checkbox checkbox-danger vendors_check"> <input  have-work="1" class="form-control" type="checkbox"  id="'+cellData+'" name="selected_vendors[]" value="' + cellData + '" ><label for="'+cellData+'"> </label></div>';
                                    else
                                        var html = ' <div class="checkbox checkbox-danger vendors_check"> <input have-work="0" class="form-control" type="checkbox"  id="'+cellData+'" name="selected_vendors[]" value="' + cellData + '" ><label for="'+cellData+'"> </label></div>';
                                    $(td).html(html);

                                }
                            },{
                                "targets": 4,
                                "orderable": false,
                                "searchable": true,
                                "createdCell": function (td, cellData, rowData, row, col) {
                                    $(td).html('');
                                    $.each(cellData, function (index, value) {
                                        var type = '';
                                        if(value['type'] === 'dma'){
                                            type = 'D';
                                        }else if(value['type'] === 'msa'){
                                            type = 'M';
                                        }else if(value['type'] === ''){
                                            type = 'C';
                                        }
                                        $(td).append('<strong>' + type + '</strong> ' + value['name']);
                                        if (index != (cellData.length - 1)) {
                                            $(td).append(' / ');
                                        }
                                    });
                                }
                            },
                            {
                                "targets": 7,
                                "orderable": false,
                                "createdCell": function (td, cellData, rowData, row, col) {

                                    var html = '<div class="row text-center"><div class="btn-group" role="group">' +
                                        '<a href="/vendors/' +
                                        cellData +
                                        '" role="button" class="btn btn-success btn-sm">' +
                                        '<i class="fa fa-pencil"></i> Edit' +
                                        '</a>';
                                    if(table_editable){
                                        if(rowData.delete== 2) {
                                            html += '<a  href="javascript:void(0)" onclick="deleteVendor(\'' + cellData + '\')" role="button" class="btn btn-danger btn-sm">' +
                                                '<i class="fa fa-trash-o"></i> Delete' +
                                                '</a></div>';
                                        }
                                        else{
                                            html += '<a disabled href="javascript:void(0)"  role="button" class="btn btn-danger btn-sm">' +
                                                '<i class="fa fa-trash-o"></i> Delete' +
                                                '</a></div>';
                                        }
                                    }

                                    html += '</div>';
                                    $(td).html(html);
                                }
                            }],
                        orderCellsTop: true
                    });
                    $('#panel_click_ven_search').addClass('panel-collapsed');
                    $('#panel_body_search_vendor').css('display', 'none');
                    app_vendors_table_datatable.clear();
                    app_vendors_table_datatable.rows.add(data);
                    app_vendors_table_datatable.draw();
                    hide_loader();
                },
                error: function (xhr) {
                    hide_loader();
                    ajax_error();
                    debug(xhr.responseText);
                }
            });
        }
    }

    var data_table_order=[0, "asc"];
    function initializeVedorsTable() {
       // window.app_vendors_table.on('preXhr.dt', function ( e, settings, data ) {
        var medias = '';
        if(medias !== "") {
            if(medias === 'tv')
                medias = "?type=dma";
            else if(medias === 'radio')
                medias = "?type=msa"
            else if(typeof create_type !== "undefined" && create_type !== "")
                medias = "?type="+create_type
        }else if(typeof create_type !== "undefined" && create_type !== "")
            medias = "?type="+create_type
        var marks  = '';
        if(marks !== "")
            marks = ((medias !== "") ? "&" : "?") + "market=" + marks;
        $('#app-vendors-table thead tr')
            .clone(true)
            .addClass('filters')
            .appendTo('#app-vendors-table thead');
        app_vendors_table_datatable= $('#app-vendors-table')/*.on('preXhr.dt', function ( e, settings, data ) {
            //$("#app-vendors-table_filter.dataTables_filter label input").attr("disabled",true)
        })*/. DataTable({
            "processing": true,
            "serverSide": true,
            ajax: {
                url: '/vendors' + medias + marks,
                dataSrc: 'data'
            },
            language: {
                "infoFiltered":"",
                "loadingRecords": '<i class="fa fa-fw fa-spinner fa-spin" style="font-size: 18px;"></i> Searching'
            },
            columns: [
                {data: 'id'},
                {data: 'name'},
                {data: 'owner'},
                {data: 'types'},
                {data: 'markets'},
                {data: 'vendor_code'},
                {data: 'vendor_pub'},
                {data: 'slug'}
            ],
            destroy: true,
            pageLength: user_entries,
            order: data_table_order,
            "columnDefs": [
                {
                    "targets": 7,
                    "orderable": false,
                },
                {
                    "targets": 5,
                    "orderable": true,
                    "searchable": true,
                },
                {
                    "targets": 6,
                    "orderable": true,
                    "searchable": true,
                },{
                "targets": 3,
                "orderable": false,
                "createdCell": function (td, cellData, rowData, row, col) {
                    $(td).html('');
                    $.each(cellData, function (index, value) {
                        $(td).append(value['name'].toUpperCase());
                        if (index != (cellData.length - 1)) {
                            $(td).append(' / ');
                        }
                    });
                }
            },
                {
                    "targets": 0,
                    "orderable": false,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        if(rowData.delete== 1)
                            var html = ' <div class="checkbox checkbox-danger vendors_check"> <input  have-work="1" class="form-control" type="checkbox"  id="'+cellData+'" name="selected_vendors[]" value="' + cellData + '" ><label for="'+cellData+'"> </label></div>';
                        else
                            var html = ' <div class="checkbox checkbox-danger vendors_check"> <input have-work="0" class="form-control" type="checkbox"  id="'+cellData+'" name="selected_vendors[]" value="' + cellData + '" ><label for="'+cellData+'"> </label></div>';
                        $(td).html(html);

                    }
                },{
                "targets": 4,
                "orderable": false,
                "searchable": true,
                "createdCell": function (td, cellData, rowData, row, col) {
                    $(td).html('');
                    $.each(cellData, function (index, value) {
                        var type = '';
                        if(value['type'] === 'dma'){
                            type = 'D';
                        }else if(value['type'] === 'msa'){
                            type = 'M';
                        }else if(value['type'] === ''){
                            type = 'C';
                        }
                        $(td).append('<strong>' + type + '</strong> ' + value['name']);
                        if (index != (cellData.length - 1)) {
                            $(td).append(' / ');
                        }
                    });
                }
            },
                {
                    "targets": 7,
                    "orderable": false,
                    "createdCell": function (td, cellData, rowData, row, col) {

                        var html = '<div class="row text-center"><div class="btn-group" role="group">' +
                            '<a href="/vendors/' +
                            cellData +
                            '" role="button" class="btn btn-success btn-sm">' +
                            '<i class="fa fa-pencil"></i> Edit' +
                            '</a>';
                        if(table_editable){
                            if(rowData.delete== 2) {
                                html += '<a  href="javascript:void(0)" onclick="deleteVendor(\'' + cellData + '\')" role="button" class="btn btn-danger btn-sm">' +
                                    '<i class="fa fa-trash-o"></i> Delete' +
                                    '</a></div>';
                            }
                            else{
                                html += '<a disabled href="javascript:void(0)"  role="button" class="btn btn-danger btn-sm">' +
                                    '<i class="fa fa-trash-o"></i> Delete' +
                                    '</a></div>';
                            }
                        }

                        html += '</div>';
                        $(td).html(html);
                    }
                }],
            orderCellsTop: true,
            initComplete: function () {
                var api = this.api();

                // For each column
                api
                    .columns()
                    .eq(0)
                    .each(function (colIdx) {
                        // Set the header cell to contain the input element
                        var cell = $('.filters th').eq(
                            $(api.column(colIdx).header()).index()
                        );
                        var title = $(cell).text();
                        if (title !== '' && title !== null && title.indexOf('Print') === -1) {
                            $(cell).html('<input style="width: 100%;margin-bottom: 10px;" class="form-control input-sm table-column-search-input" data-toggle="tooltip" data-placement="top" data-original-title="Search ' + title + '" type="text" />');
                        } else {
                            $(cell).html('');
                        }

                        // On every keypress in this input
                        $(
                            'input',
                            $('.filters th').eq($(api.column(colIdx).header()).index())
                        )
                            .off('keyup')
                            .on('keyup', function (e) {
                                e.stopPropagation();

                                // Get the search value
                                $(this).attr('title', $(this).val());
                                var regexr = '{search}'; //$(this).parents('th').find('select').val();

                                var cursorPosition = this.selectionStart;
                                // Search the column for that value
                                api
                                    .column(colIdx)
                                    .search(
                                        this.value != ''
                                            ? regexr.replace('{search}', this.value)
                                            : '',
                                        this.value != '',
                                        this.value == ''
                                    )
                                    .draw();

                                $(this)
                                    .focus()[0]
                                    .setSelectionRange(cursorPosition, cursorPosition);
                            });
                    });
                    $('[data-toggle="tooltip"]').tooltip();
            }
        });
        // app_vendors_table_datatable.columns().every(function () {
        //     var table = this;
        //     console.log('table', table);
        //     $('input', this.header()).on('keyup', function () {
        //         const currentValue = this.value;
        //         $('input.table-column-search-input').each(function() {
        //             this.value = '';
        //         });
        //         this.value = currentValue;
        //         if (table.search() !== this.value) {
        //             table.search(this.value).draw();
        //         }
        //     });
        // });
    }
    $('#app-vendors-table').on( 'length.dt', function ( e, settings, len ) {
        user_entries= len;
    });
    $('#app-vendors-table').on( 'order.dt', function ( e, settings, len) {
        data_table_order=[len[0].col, ""+len[0].dir+""];
    } );

    function deleteVendor(url) {
        $('#deleteVendorWarningDiv').html("This action will delete all data related with this vendor.\n Are you sure you want to delete?");
        $('#deletedVendorConfirm').attr('data-url', url)
        $('#deletedVendorConfirm').show();
        $('#deletedVendorMultConfirm').hide();
        $('#deleteVendorWarningModal').modal('show');
    }
    function deletedVendorConfirm(){
        show_loader();
        $('#deleteVendorWarningModal').modal('hide');
        var url = $('#deletedVendorConfirm').attr('data-url');
        $.ajax({
            url: '/vendors/' + url + '/destroy',
            success: function (response) {
                global_notification('success', 'Vendor deleted.');
                var market= $('#market-search-vendor-index').val();
                var market_msa= $('#market-search-vendor-index-msa').val();
                var market_custom= $('#market-search-vendor-index-custom').val();
                var media= $('#media-search-vendor-index').val();
                var owner= $('#owner-search-vendor-index').val();

                if((market_custom =='' || market_custom== null) && (  market_msa=='' || market_msa== null) &&(  market=='' || market== null) &&(typeof media=='undefined' || media=='' || media== null) && (owner =='' || owner== null))
                    initializeVedorsTable();
                else
                    SearchVendor();

                hide_loader();
            },
            error: function (xhr) {
                if (xhr.status == 422) {
                    global_notification('warning', xhr.responseJSON.message);
                } else {
                    ajax_error();
                    debug(xhr.responseText);
                }
                hide_loader();
            }
        });
    }

    $('#select_all_vendors').on('click', function (e) {
        $('#app-vendors-table  input:checkbox').each(function () {
            if ($(this).prop('disabled')=== false)
                $(this).prop('checked', true);
        });
    });
    $('#deselect_all_vendors').on('click', function (e) {
        $('#app-vendors-table input:checkbox').prop('checked', false);
    });

    $('#delete_multiple_vendors').on('click', function (e) {
        var url = $(this).attr('data-url');
        var selectedItems = [];
        var cont=0;
        $('.vendors_check input[type=checkbox]').each(function () {
            if (this.checked) {
                selectedItems.push($(this).val());
                if($(this).attr('have-work')==1)
                    cont++;
            }
        });
        if(cont == 0)
             var ms = "This action will delete all data related with the selected vendors.\n Are you sure you want to delete?";
        else
            var ms = "Vendors with created orders will not be deleted. Are you sure you want to delete?";

        if (selectedItems.length > 0){
            $('#deleteVendorWarningDiv').html(ms);
            $('#deletedVendorMultConfirm').attr('data-url', url)
            $('#deletedVendorMultConfirm').show();
            $('#deletedVendorConfirm').hide();
            $('#deleteVendorWarningModal').modal('show');
            hide_loader();
        }
        else{
            $('#generalWarningModalDiv').html('Please select at least one Vendor.');
            $('#generalWarningModal').modal('show');
        }
    });
    function deletedVendorMultConfirm() {
        show_loader();
        $('#deleteVendorWarningModal').modal('hide');
        var urlVar = $('#deletedVendorMultConfirm').attr('data-url');
        var selectedItems = [];
        $('.vendors_check input[type=checkbox]').each(function () {
            if (this.checked) {
                selectedItems.push($(this).val());
            }
        });
        var params = {
            vendors: selectedItems,
        };
        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data: JSON.stringify(params),
            url: urlVar,
            dataType: "json",
            contentType: "application/json",
            success: function (response) {
                global_notification('success', 'Vendors deleted.');
                var market= $('#market-search-vendor-index').val();
                var market_msa= $('#market-search-vendor-index-msa').val();
                var market_custom= $('#market-search-vendor-index-custom').val();
                var media= $('#media-search-vendor-index').val();
                var owner= $('#owner-search-vendor-index').val();

                if((market_custom =='' || market_custom== null) && (  market_msa=='' || market_msa== null) &&(  market=='' || market== null) &&(typeof media=='undefined' || media=='' || media== null) && (owner =='' || owner== null))
                    initializeVedorsTable();
                else
                    SearchVendor();

                hide_loader();
            },
            error: function (xhr) {
                hide_loader();
                ajax_error();
                debug(xhr.responseText);

            }
        });
    }

    initializeVedorsTable();

    var columnDeftDuplicatedVendor = [
        {
            headerName: '',
            headerTooltip: '',
            field: 'row_select',
            pinned: 'left',
            width: 50,
            editable: false,
            cellRenderer: 'agGroupCellRenderer',
            checkboxSelection: true,
            cellRendererParams: {
                //checkbox: true
            },
            suppressFilter: true,
            suppressMovable: true,
            suppressResize: true,
            suppressNavigable: true,
            suppressSorting: true,
            required: true,
            headerClass: 'fixedHeaderCellClass'
        },
        {
            headerName: "Vendor Name",
            field: 'vendor_name',
            width: 250,
            cellStyle: {'text-align': "right"}
        }, {
            headerName: "Quantity",
            field: 'quantity',
            width: 120,
            cellStyle: {'text-align': "center"}
        },
    ];
    var gridDuplicatedVendor = {
        columnDefs: columnDeftDuplicatedVendor,
        defaultColDef: {
            suppressToolPanel: true
        },
        rowSelection: 'multiple',
        suppressRowClickSelection: true,
        enableColResize: true,
        //suppressMenuColumnPanel: true,
        suppressTouch: true,
        headerHeight: 30,
        suppressDragLeaveHidesColumns: true,
        enableCellChangeFlash: true,
        rowHeight: 22,
        suppressRowHoverClass: true,
        suppressParentsInRowNodes: true,
        toolPanelSuppressValues: true,
        toolPanelSuppressRowGroups: true,
        groupUseEntireRow: false,
        suppressAggFuncInHeader: true,
        enableFilter: false,
        enableSorting: true,
        animateRows: true,
        icons: {
            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        },
        getContextMenuItems: getContextMenuInvoiceOrder,
        onSelectionChanged: function (e) {

        },
    };

    $('#select_all_lines_dup_ven').on('click', function(){
        gridDuplicatedVendor.api.selectAll();
    });
    $('#deselect_all_lines_dup_ven').on('click', function(){
        gridDuplicatedVendor.api.deselectAll();
    });

    $('#delete_duplicate_vendors').on('click', function () {
        show_loader();
        $('#filter_gridDuplicatedVendor').hide();
        $.ajax({
            type: 'GET',
            url: '/get/duplicated/vendors',
            dataType: 'json',
            encode: true,
            success: function (data) {
                var html = '<option></option>';
                $('#keywordsFilterDuplicatedVendors').html('');
                for(var i in data)
                    html += '<option> '+ data[i].vendor_name +' </option>';
                $('#keywordsFilterDuplicatedVendors').html(html);
                $('#keywordsFilterDuplicatedVendors').select2({
                    placeholder: "Filter",
                    minimumResultsForSearch: 5
                }).on('select2:select', function (evt) {
                    gridDuplicatedVendor.api.setQuickFilter($('#keywordsFilterDuplicatedVendors option:selected').val());
                    $('#filter_gridDuplicatedVendor').show();
                });
                console.log('html', html);


                gridDuplicatedVendor.rowData = [];
                gridDuplicatedVendor.rowData = data;
                $('#deleteDuplicatedVendorsDiv').html("");
                var gridDuplicatedVendorGrid = document.querySelector('#deleteDuplicatedVendorsDiv');
                var g5 = new agGrid.Grid(gridDuplicatedVendorGrid, gridDuplicatedVendor);

                $('#DeleteDuplicatedVendorsModal').modal({backdrop: 'static', keyboard: false})
                $('#DeleteDuplicatedVendorsModal').modal('show');
                hide_loader();
            },
            error: function (xhr) {
                debug(xhr.responseText);
                hide_loader();
            }
        });

    });
    $('#filter_gridDuplicatedVendor').on('click', function () {
        $('#keywordsFilterDuplicatedVendors').val('').select2().change();
        gridDuplicatedVendor.api.setQuickFilter($('#keywordsFilterDuplicatedVendors option:selected').val());
        $('#filter_gridDuplicatedVendor').hide();
    });

    $('#delete_vendors_dup').on('click', function () {
        var params = {
            lines: [],
        }
        var selectedNodes = gridDuplicatedVendor.api.getSelectedNodes();
        if (selectedNodes.length === 0) {
            $('#generalWarningModalVendor').modal('show');
            $('#generalWarningModalDivVendor').html('Please select at least one vendor first');
        } else {
            show_overlay_loader('#DeleteDuplicatedVendorsModal');
            for (var ind in selectedNodes)
                params.lines.push(selectedNodes[ind].data.vendor_name);
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: JSON.stringify(params),
                url: '/delete/duplicated/vendors',
                dataType: "json",
                contentType: "application/json",
                success: function (data) {
                    global_notification('success', 'Duplicated vendors deleted.')
                    hide_overlay_loader('#DeleteDuplicatedVendorsModal');
                    if (data.locked !== '') {
                        $('#generalWarningModalVendor').modal('show');
                        $('#generalWarningModalDivVendor').html(data.locked);
                    }
                    $('#delete_duplicate_vendors').click();

                },
                error: function (xhr) {
                    hide_overlay_loader('#DeleteDuplicatedVendorsModal');
                    ajax_error();
                    debug(xhr.responseText);
                }
            });
        }
    });
}
